import fetch from "isomorphic-unfetch";
import axios, { AxiosResponse } from 'axios';
import mockNodePoints from '../mocks/point_interest.json';
import { NodePoint, Route } from '../types/types';
import configService from '../services/configService';

// Las URLs ahora se obtienen dinámicamente del configService
const getApiBaseUrl = () => configService.getApiBaseUrl();
const getOsrmUrl = () => configService.getOsrmUrl();
const shouldUseMockData = () => configService.shouldUseMockData();

interface CustomRoute {
  original: number[];
  destination: number[];
}

const routerApi = {
  getRoute(routeObject: CustomRoute): Promise<any> {
    console.log(routeObject);
    const original: string = [...routeObject.original].reverse().join(",");
    const destination: string = [...routeObject.destination].reverse().join(",");
    const osrmUrl = getOsrmUrl();

    return fetch(
      `${osrmUrl}/route/v1/car/${original};${destination}?overview=full`
    ).then((response: Response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.clone().json();
    }).catch((error) => {
      console.error('Error fetching route:', error);
      throw error; // Re-throw to be caught by the saga
    });
  },

  async getRoutes(): Promise<any> {
      // Get tenant ID to load the correct JSON file
      const tenantId = configService.getConfig().tenantId;

      try {
        // Dynamic import based on tenant ID
        // Convention: JSON file name must match tenantId (e.g., enkartur.json, proyecto2.json)
        // Webpack will code-split these - only the needed file downloads to client
        const routesData = await import(`../rutas-cicloturismo/${tenantId}.json`);

        // Dynamic imports return a module with 'default' property
        const routes = routesData.default || routesData;

        const Routes: Route[] = routes.map((route: any) => ({
          id: route.route_id,
          nombre: route.nombre,
          descripción: route.descripción,
          distancia: route.distancia,
          desnivel: route.desnivel,
          dificultad: route.dificultad,
          url_gpx_s3: route.url_gpx_s3,
          owner_id: route.owner_id,
          signed_url: route.signed_url,
          greatRoute: Boolean(route.great_route)
        }));

        return Routes;
      } catch (error) {
        console.error(`Error loading routes for tenant ${tenantId}:`, error);
        console.error(`Make sure the file src/rutas-cicloturismo/${tenantId}.json exists`);
        throw error;
      }

  },

  getNodePoints(): Promise<any> {
    if (shouldUseMockData()) {
      const nodePoints: NodePoint[] = (mockNodePoints as any).map((point: any) => ({
        id: point.place_id,
        lat: Number(point.latitude),
        lon: Number(point.longitude),
        title: point.name,
        text: point.full_address,
        description: point.description,
        url: point.location_link
      }));
      return Promise.resolve(nodePoints);
    }

    const apiBaseUrl = getApiBaseUrl();
    return axios
      .get(
        `${apiBaseUrl}/getNodePoints`,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        }
      )
      .then((response: AxiosResponse) => response.data.Items)
      .catch((error: any) => {
        console.error('Error fetching node points:', error);
        throw error; // Re-throw to be handled by the saga
      });
  }
};

export default routerApi;


/* getRoute(routeObject: CustomRoute){
  console.log(routeObject);
  const original: string = [...routeObject.original].reverse().join(",");
  const destination: string = [...routeObject.destination].reverse().join(",");

  axios
    .get(
      `http://router.project-osrm.org/route/v1/driving/${original};${destination}?steps=true&geometries=geojson&overview=full`,
      {
        headers: {
          'Content-Type': 'application/json'
        },

      }

    )
    .then((response) => {
      console.log(response);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });

}, */
